import NavigationError from "@/errors/navigation-error";
import useMeQuery from "@/hooks/use-me-query";
import usePermissions from "@/hooks/use-permissions";
import selectUser from "@/utils/select-user";
import { FC, ReactNode } from "react";
import { Outlet } from "react-router";

const ManagerGuard: FC<{ children?: ReactNode }> = ({ children }) => {
  const { data } = useMeQuery();
  const user = selectUser(data);
  const { can } = usePermissions();

  if (!user.managerId && !can("skip-manager")) {
    throw new NavigationError("/401");
  }
  return children ?? <Outlet />;
};

export default ManagerGuard;
